export default data => ({ ...data, stav: data.stav?.name });
